import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import PropTypes from "prop-types"

/**
 *
 * @param {initials} (if logo is not present, initials will be rendered)
 * @param {logo}
 * @param {size}
 */
const Avatar = ({
  initials,
  logo,
  size = "tw-w-[45px] tw-h-[45px]",
  iconName,
  backgroundColor,
  iconColor,
  borderColor,
  disabled,
  fontSize = "tw-text-base",
}: $TSMigrationFixMe) => {
  const sizeClass = size

  if (logo) {
    return (
      <img
        src={logo}
        alt={initials}
        className={`tw-flex tw-justify-center tw-items-center tw-rounded-full ${sizeClass} tw-object-contain tw-object-center`}
      />
    )
  }
  if (iconName) {
    return (
      <div
        className={`tw-flex tw-justify-center tw-items-center tw-rounded-full tw-font-medium tw-text-white ${sizeClass} ${disabled}`}
        style={{ backgroundColor, border: `1px solid ${borderColor}` }}
      >
        <FontAwesomeIcon
          color={iconColor}
          className='card-approval-icon'
          icon={["fal", iconName]}
          style={{ color: iconColor }}
        />
      </div>
    )
  }

  return (
    <div
      className={`tw-flex tw-justify-center tw-items-center tw-rounded-full tw-font-normal ${fontSize} tw-text-white tw-bg-primary ${sizeClass}`}
      style={{ backgroundColor }}
    >
      {initials || "NN"}
    </div>
  )
}

Avatar.propTypes = {
  initials: PropTypes.string,
  logo: PropTypes.string,
  size: PropTypes.oneOf(["small", "normal", "big"]),
  iconName: PropTypes.string,
  iconColor: PropTypes.string,
  backgroundColor: PropTypes.string,
  borderColor: PropTypes.string,
}

export default Avatar
